module.exports = __webpack_public_path__ + "img/bd.e99cb11f.svg";